// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage } from "react-intl";

export const OrganizationAssets = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.organizationAssets"
        description="Organization assets."
        defaultMessage="Organization Assets"
    />
);
OrganizationAssets.displayName = "OrganizationAssets";

export const Notice = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.notice"
        description="Notice."
        defaultMessage="Important Information Regarding Your Lens Studio Assets"
    />
);
Notice.displayName = "Notice";

export const NoticeBody = (props: { assets: ReactNode; organization: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.noticeBody"
        description="Notice body."
        defaultMessage="The following assets: {assets} have been automatically assigned to the organization {organization}."
        values={props}
    />
);
NoticeBody.displayName = "NoticeBody";

export const ReadyForSubmission = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.readyForSubmission"
        description="Ready for submission."
        defaultMessage="Ready for Submission"
    />
);
ReadyForSubmission.displayName = "ReadyForSubmission";

export const RequiredFieldsMissing = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.requiredFieldsMissing"
        description="Required fields missing."
        defaultMessage="Required Fields Missing"
    />
);
RequiredFieldsMissing.displayName = "RequiredFieldsMissing";

export const Draft = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.draft" description="Draft." defaultMessage="In Draft state" />
);
Draft.displayName = "Draft";

export const Publish = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.publish" description="Publish." defaultMessage="Publish" />
);
Publish.displayName = "Publish";

export const Asset = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.asset" description="Asset." defaultMessage="Asset" />
);
Asset.displayName = "Asset";

export const UploadAsset = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.uploadAsset"
        description="Upload asset."
        defaultMessage="Upload Asset"
    />
);
UploadAsset.displayName = "UploadAsset";

export const Thumbnail = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.thumbnail" description="Thumbnail." defaultMessage="Thumbnail" />
);
Thumbnail.displayName = "Thumbnail";

export const ThumbnailHint = (props: { guideLink: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.thumbnailHint"
        description="Thumbnail hint."
        defaultMessage="512×512 .png with a transparent background. Use the template from the {guideLink} if needed."
        values={props}
    />
);
ThumbnailHint.displayName = "ThumbnailHint";

export const UploadPhoto = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.uploadPhoto"
        description="Upload photo."
        defaultMessage="Upload Image / Preview"
    />
);
UploadPhoto.displayName = "UploadPhoto";

export const Name = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.name" description="Name." defaultMessage="Name" />
);
Name.displayName = "Name";

export const Type = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.type" description="Type." defaultMessage="Type" />
);
Type.displayName = "Type";

export const TypeDefault = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.typeDefault" description="Type default." defaultMessage="Default" />
);
TypeDefault.displayName = "TypeDefault";

export const TypeAssetPackage = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.typeAssetPackage"
        description="Type asset package."
        defaultMessage="Asset Package"
    />
);
TypeAssetPackage.displayName = "TypeAssetPackage";

export const TypeCustomComponent = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.typeCustomComponent"
        description="Type custom component."
        defaultMessage="Custom Component"
    />
);
TypeCustomComponent.displayName = "TypeCustomComponent";

export const TypePlugin = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.typePlugin" description="Type plugin." defaultMessage="Plugin" />
);
TypePlugin.displayName = "TypePlugin";

export const TypeHintDefault = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.typeHintDefault"
        description="Type hint default."
        defaultMessage="Default — any .lspkg, the most common choice."
    />
);
TypeHintDefault.displayName = "TypeHintDefault";

export const TypeHintAssetPackage = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.typeHintAssetPackage"
        description="Type hint asset package."
        defaultMessage="Asset Package — an .lspkg. Create a package in Lens Studio and export it."
    />
);
TypeHintAssetPackage.displayName = "TypeHintAssetPackage";

export const TypeHintCustomComponent = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.typeHintCustomComponent"
        description="Type hint custom component."
        defaultMessage="Custom Component — .lsc scripts and custom components."
    />
);
TypeHintCustomComponent.displayName = "TypeHintCustomComponent";

export const TypeHintPlugin = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.typeHintPlugin"
        description="Type hint plugin."
        defaultMessage="Plugin — Lens Studio plugins, submitted as a .zip."
    />
);
TypeHintPlugin.displayName = "TypeHintPlugin";

export const Description = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.description" description="Description." defaultMessage="Description" />
);
Description.displayName = "Description";

export const DescriptionPlaceholder = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.descriptionPlaceholder"
        description="Description placeholder."
        defaultMessage="Describe your asset — what it does and how to use it."
    />
);
DescriptionPlaceholder.displayName = "DescriptionPlaceholder";

export const Category = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.category" description="Category." defaultMessage="Categories" />
);
Category.displayName = "Category";

export const License = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.license" description="License." defaultMessage="License" />
);
License.displayName = "License";

export const UploadDocument = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.uploadDocument"
        description="Upload document."
        defaultMessage="Upload Document"
    />
);
UploadDocument.displayName = "UploadDocument";

export const NewAssetTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.newAssetTitle"
        description="New asset title."
        defaultMessage="New Asset"
    />
);
NewAssetTitle.displayName = "NewAssetTitle";

export const AllAssets = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.allAssets" description="All assets." defaultMessage="All Assets" />
);
AllAssets.displayName = "AllAssets";

export const AddAsset = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.addAsset" description="Add asset." defaultMessage="Add Asset" />
);
AddAsset.displayName = "AddAsset";

export const Submit = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.submit" description="Submit." defaultMessage="Submit" />
);
Submit.displayName = "Submit";

export const SubmitAnother = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.submitAnother"
        description="Submit another."
        defaultMessage="Submit another asset"
    />
);
SubmitAnother.displayName = "SubmitAnother";

export const OrganizationsLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.organizationsLabel"
        description="Organizations label."
        defaultMessage="Select Organization"
    />
);
OrganizationsLabel.displayName = "OrganizationsLabel";

export const Confirm = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.confirm" description="Confirm." defaultMessage="Confirm" />
);
Confirm.displayName = "Confirm";

export const NewAssetButtonText = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.newAssetButtonText"
        description="New asset button text."
        defaultMessage="Create Asset"
    />
);
NewAssetButtonText.displayName = "NewAssetButtonText";

export const AssetErrorFileTooLarge = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.assetErrorFileTooLarge"
        description="Asset error file too large."
        defaultMessage="File is too large."
    />
);
AssetErrorFileTooLarge.displayName = "AssetErrorFileTooLarge";

export const AssetErrorFileType = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.assetErrorFileType"
        description="Asset error file type."
        defaultMessage="Invalid file type."
    />
);
AssetErrorFileType.displayName = "AssetErrorFileType";

export const AssetErrorDefault = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.assetErrorDefault"
        description="Asset error default."
        defaultMessage="There was an error processing your request. Please try again."
    />
);
AssetErrorDefault.displayName = "AssetErrorDefault";

export const AssetErrorUploadFailed = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.assetErrorUploadFailed"
        description="Asset error upload failed."
        defaultMessage="We couldn't upload your files. Nothing was submitted — please try again."
    />
);
AssetErrorUploadFailed.displayName = "AssetErrorUploadFailed";

export const AssetFileTypes = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.assetFileTypes"
        description="Asset file types."
        defaultMessage="The following file types are supported for asset uploads:"
    />
);
AssetFileTypes.displayName = "AssetFileTypes";

export const AssetSubtitle = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.assetSubtitle"
        description="Asset subtitle."
        defaultMessage="Plugins should be submitted as .zip files."
    />
);
AssetSubtitle.displayName = "AssetSubtitle";

export const PermissionsDeniedTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.permissionsDeniedTitle"
        description="Permissions denied title."
        defaultMessage="Permissions Denied"
    />
);
PermissionsDeniedTitle.displayName = "PermissionsDeniedTitle";

export const PermissionsDeniedContent = (props: { link: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.permissionsDeniedContent"
        description="Permissions denied content."
        defaultMessage="You do not have permissions to view or create Lens Studio assets for this organization. Check your organization membership settings in {link}."
        values={props}
    />
);
PermissionsDeniedContent.displayName = "PermissionsDeniedContent";

export const AssetLibrarySubtext = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.assetLibrarySubtext"
        description="Asset library subtext."
        defaultMessage="Asset Library Publishing Guide"
    />
);
AssetLibrarySubtext.displayName = "AssetLibrarySubtext";

export const AssetLibraryNote = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.assetLibraryNote"
        description="Asset library note."
        defaultMessage="Approved assets are published in the Asset Library for other creators to use and build upon."
    />
);
AssetLibraryNote.displayName = "AssetLibraryNote";

export const Guidelines = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.guidelines" description="Guidelines." defaultMessage="guidelines" />
);
Guidelines.displayName = "Guidelines";

export const Here = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.here" description="Here." defaultMessage="here" />
);
Here.displayName = "Here";

export const Note = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.note" description="Note." defaultMessage="Note" />
);
Note.displayName = "Note";

export const NoAssetsMessage = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.noAssetsMessage"
        description="No assets message."
        defaultMessage="No assets uploaded yet."
    />
);
NoAssetsMessage.displayName = "NoAssetsMessage";

export const StatusReadyTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.statusReadyTitle"
        description="Status ready title."
        defaultMessage="Ready to submit"
    />
);
StatusReadyTitle.displayName = "StatusReadyTitle";

export const StatusReadySubtitle = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.statusReadySubtitle"
        description="Status ready subtitle."
        defaultMessage="All required fields complete."
    />
);
StatusReadySubtitle.displayName = "StatusReadySubtitle";

export const StatusIncompleteSubtitle = (props: { count: ReactNode; total: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.statusIncompleteSubtitle"
        description="Status incomplete subtitle."
        defaultMessage="{count} of {total} fields still need attention."
        values={props}
    />
);
StatusIncompleteSubtitle.displayName = "StatusIncompleteSubtitle";

export const StatusSubmittedTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.statusSubmittedTitle"
        description="Status submitted title."
        defaultMessage="Submitted for review"
    />
);
StatusSubmittedTitle.displayName = "StatusSubmittedTitle";

export const StatusSubmittedSubtitle = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.statusSubmittedSubtitle"
        description="Status submitted subtitle."
        defaultMessage="We'll email you when it's approved."
    />
);
StatusSubmittedSubtitle.displayName = "StatusSubmittedSubtitle";

export const ErrorSummaryTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.errorSummaryTitle"
        description="Error summary title."
        defaultMessage="Fix these before submitting"
    />
);
ErrorSummaryTitle.displayName = "ErrorSummaryTitle";

export const DerivedCategoryCaption = (props: { category: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.derivedCategoryCaption"
        description="Derived category caption."
        defaultMessage="{category} is set automatically from your Type."
        values={props}
    />
);
DerivedCategoryCaption.displayName = "DerivedCategoryCaption";

export const DragDropPrompt = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.dragDropPrompt"
        description="Drag drop prompt."
        defaultMessage="Drag & drop or browse"
    />
);
DragDropPrompt.displayName = "DragDropPrompt";

export const AssetDropHint = (props: { formats: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.assetDropHint"
        description="Asset drop hint."
        defaultMessage="Accepts {formats} · up to 100 MB"
        values={props}
    />
);
AssetDropHint.displayName = "AssetDropHint";

export const ThumbnailDropHint = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.thumbnailDropHint"
        description="Thumbnail drop hint."
        defaultMessage=".png · up to 2 MB"
    />
);
ThumbnailDropHint.displayName = "ThumbnailDropHint";

export const RemoveFile = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.removeFile" description="Remove file." defaultMessage="Remove" />
);
RemoveFile.displayName = "RemoveFile";

export const NameRequired = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.nameRequired"
        description="Name required."
        defaultMessage="Give your asset a name."
    />
);
NameRequired.displayName = "NameRequired";

export const CategoryRequired = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.categoryRequired"
        description="Category required."
        defaultMessage="Pick at least one category."
    />
);
CategoryRequired.displayName = "CategoryRequired";

export const AssetRequired = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.assetRequired"
        description="Asset required."
        defaultMessage="Upload your asset file (.lspkg, .lsc, or .zip)."
    />
);
AssetRequired.displayName = "AssetRequired";

export const ThumbnailRequired = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.thumbnailRequired"
        description="Thumbnail required."
        defaultMessage="Upload a thumbnail image (.png)."
    />
);
ThumbnailRequired.displayName = "ThumbnailRequired";

export const DescriptionRequired = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.descriptionRequired"
        description="Description required."
        defaultMessage="Describe your asset so others know how to use it."
    />
);
DescriptionRequired.displayName = "DescriptionRequired";

export const AssetInvalidType = (props: { fileName: ReactNode; formats: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.assetInvalidType"
        description="Asset invalid type."
        defaultMessage={'"{fileName}" isn\'t a supported asset. Use a {formats} file.'}
        values={props}
    />
);
AssetInvalidType.displayName = "AssetInvalidType";

export const AssetTooLarge = (props: { fileName: ReactNode; size: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.assetTooLarge"
        description="Asset too large."
        defaultMessage='"{fileName}" is {size} — the limit is 100 MB.'
        values={props}
    />
);
AssetTooLarge.displayName = "AssetTooLarge";

export const ThumbnailInvalidType = (props: { fileName: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.thumbnailInvalidType"
        description="Thumbnail invalid type."
        defaultMessage={'"{fileName}" isn\'t a .png. Use a .png file.'}
        values={props}
    />
);
ThumbnailInvalidType.displayName = "ThumbnailInvalidType";

export const ThumbnailTooLarge = (props: { fileName: ReactNode; size: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.thumbnailTooLarge"
        description="Thumbnail too large."
        defaultMessage='"{fileName}" is {size} — thumbnails must be under 2 MB.'
        values={props}
    />
);
ThumbnailTooLarge.displayName = "ThumbnailTooLarge";

export const PreviewAssetName = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.previewAssetName"
        description="Preview asset name."
        defaultMessage="Asset name"
    />
);
PreviewAssetName.displayName = "PreviewAssetName";

export const PreviewCreator = (props: { creator: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.previewCreator"
        description="Preview creator."
        defaultMessage="by {creator}"
        values={props}
    />
);
PreviewCreator.displayName = "PreviewCreator";

export const PreviewYou = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.previewYou" description="Preview you." defaultMessage="you" />
);
PreviewYou.displayName = "PreviewYou";

export const PreviewAllPlatforms = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.previewAllPlatforms"
        description="Preview all platforms."
        defaultMessage="All Platforms"
    />
);
PreviewAllPlatforms.displayName = "PreviewAllPlatforms";

export const PreviewNoDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.previewNoDescription"
        description="Preview no description."
        defaultMessage="No description yet"
    />
);
PreviewNoDescription.displayName = "PreviewNoDescription";

export const ActionImport = (): ReactElement => (
    <FormattedMessage id="apps.assets.components.actionImport" description="Action import." defaultMessage="Import" />
);
ActionImport.displayName = "ActionImport";

export const ActionInstall = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.actionInstall"
        description="Action install."
        defaultMessage="Install"
    />
);
ActionInstall.displayName = "ActionInstall";

export const PreviewInfoLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.previewInfoLabel"
        description="Preview info label."
        defaultMessage="View asset description"
    />
);
PreviewInfoLabel.displayName = "PreviewInfoLabel";

export const StatusInReview = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.statusInReview"
        description="Status in review."
        defaultMessage="In Review"
    />
);
StatusInReview.displayName = "StatusInReview";

export const StatusPublished = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.statusPublished"
        description="Status published."
        defaultMessage="Published"
    />
);
StatusPublished.displayName = "StatusPublished";

export const StatusProcessing = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.statusProcessing"
        description="Status processing."
        defaultMessage="Processing"
    />
);
StatusProcessing.displayName = "StatusProcessing";

export const StatusRejected = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.statusRejected"
        description="Status rejected."
        defaultMessage="Rejected"
    />
);
StatusRejected.displayName = "StatusRejected";

export const StatusUploadFailed = (): ReactElement => (
    <FormattedMessage
        id="apps.assets.components.statusUploadFailed"
        description="Status upload failed."
        defaultMessage="Upload Failed"
    />
);
StatusUploadFailed.displayName = "StatusUploadFailed";
